import styled from 'styled-components';

export const ContentStyles = styled.main`
  width: 100%;
  max-width: 960px;
  margin: 0 auto;
  padding: 8px 2px 12px;
  font-stretch: condensed;
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  .occupation-tool {
    width: 100%;
    height: auto;
  }

  .search-wrap {
    width: 100%;
    margin-bottom: 12px;
  }

  .occupation-select__control {
    min-height: 50px;
    border: 1px solid #c8d1df;
    border-radius: 9px;
    background: #fff;
    box-shadow: none;
  }

  .occupation-select__control:hover {
    border-color: #8a96a8;
  }

  .occupation-select__control--is-focused {
    border-color: #5b168c;
    box-shadow: 0 0 0 2px rgb(91 22 140 / 16%);
  }

  .occupation-select__input-container,
  .occupation-select__single-value,
  .occupation-select__placeholder {
    font-family: 'SBS Sans', sans-serif;
    font-stretch: condensed;
    font-size: 1rem;
  }

  .occupation-select__menu {
    z-index: 5;
    overflow: hidden;
    border: 1px solid #d8dee8;
    border-radius: 9px;
    box-shadow: 0 8px 24px rgb(20 30 48 / 14%);
  }

  .occupation-select__option {
    font-stretch: condensed;
  }

  .occupation-select__option--is-focused {
    background: #f1eafa;
  }

  .occupation-select__option--is-selected {
    background: #5b168c;
  }

  .table-tools {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 10px;
  }

  .results-count {
    margin: 0;
    color: #5d687a;
    font-size: 0.95rem;
  }

  .table-scroll {
    overflow: visible;
    border: 1px solid #d8dee8;
    border-radius: 10px;
    background: #fff;
  }

  .desktop-table {
    width: 100%;
    border-collapse: collapse;
    text-align: left;
  }

  .desktop-table th,
  .desktop-table td {
    padding: 10px 12px;
    border-bottom: 1px solid #e1e6ee;
    vertical-align: middle;
  }

  .desktop-table thead {
    position: sticky;
    z-index: 1;
    top: 0;
    background: #f3f5f8;
  }

  .desktop-table th {
    color: #566176;
    font-size: 0.9rem;
    font-weight: 700;
  }

  .desktop-table th button {
    padding: 0;
    border: 0;
    background: transparent;
    color: #263247;
    cursor: pointer;
    font: inherit;
    font-size: inherit;
    font-weight: inherit;
  }

  .desktop-table th button:hover {
    color: #5b168c;
  }

  .desktop-table th button:focus-visible,
  .pagination button:focus-visible {
    outline: 2px solid #5b168c;
    outline-offset: 2px;
  }

  .desktop-table tbody tr:last-child td {
    border-bottom: 0;
  }

  .desktop-table tbody tr:hover {
    background: #faf9fc;
  }

  .osca-code {
    display: block;
    margin-top: 2px;
    color: #697589;
    font-size: 0.8em;
    font-stretch: condensed;
    font-weight: 700;
    letter-spacing: 0.025em;
  }

  .desktop-table .rating-heading,
  .desktop-table .rating-cell {
    min-width: 56px;
    padding-right: 4px;
    padding-left: 4px;
    text-align: center;
  }

  .desktop-table .rating-heading {
    white-space: nowrap;
  }

  .mobile-cards {
    display: none;
  }

  .empty-state {
    margin: 0;
    padding: 24px;
    color: #5d687a;
  }

  .pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 14px;
    padding-top: 12px;
    color: #4d596d;
    font-size: 0.95rem;
  }

  .pagination button {
    padding: 7px 12px;
    border: 1px solid #c8d1df;
    border-radius: 7px;
    background: #fff;
    color: #263247;
    cursor: pointer;
    font: inherit;
  }

  .pagination button:hover:not(:disabled) {
    border-color: #5b168c;
    background: #f7f2fb;
  }

  .pagination button:disabled {
    cursor: default;
    opacity: 0.45;
  }

  @media (max-width: 600px) {
    padding: 6px 2px 8px;

    .table-tools {
      justify-content: center;
      margin-bottom: 8px;
    }

    .results-count {
      text-align: center;
    }

    .table-scroll {
      border: 0;
      border-radius: 0;
      background: transparent;
    }

    .desktop-table {
      display: none;
    }

    .mobile-cards {
      display: grid;
      gap: 10px;
    }

    .occupation-card {
      overflow: hidden;
      border: 1px solid #d8dee8;
      border-radius: 9px;
      background: #fff;
      box-shadow: 0 2px 7px rgb(20 30 48 / 8%);
    }

    .occupation-card > header {
      padding: 12px 14px;
      border-bottom: 1px solid #e1e6ee;
      background: #f3f5f8;
    }

    .occupation-card h2 {
      margin: 0;
      color: #172033;
      font-size: 1.2rem;
      line-height: 1.2;
    }

    .card-ratings {
      padding: 12px 14px;
    }

    .current-rating {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-bottom: 10px;
      border-bottom: 1px solid #e1e6ee;
    }

    .rating-label {
      color: #566176;
      font-size: 0.9rem;
      font-weight: 700;
    }

    .past-ratings {
      display: grid;
      grid-template-columns: repeat(5, minmax(0, 1fr));
      gap: 4px;
      padding-top: 10px;
    }

    .year-rating {
      display: flex;
      align-items: center;
      flex-direction: column;
      gap: 5px;
      color: #566176;
      font-size: 0.85rem;
    }

    .year-rating .rating-code {
      width: 38px;
      height: 38px;
      flex-basis: 38px;
      border-radius: 9px;
    }
  }
`;
